module.exports = __webpack_public_path__ + "img/POB.9170d5e0.jpg";